import { defineAsyncComponent } from 'vue';
import { defineModal } from './defineModal';

export const confirm = defineModal(
  defineAsyncComponent(() => import('./components/ConfirmModal.vue')),
  false,
);

export const confirmPassword = defineModal(
  defineAsyncComponent(() => import('./components/ConfirmPasswordModal.vue')),
  undefined,
);

export const link = defineModal(
  defineAsyncComponent(() => import('./components/LinkModal.vue')),
  undefined,
);

export const confirmText = defineModal(
  defineAsyncComponent(() => import('./components/ConfirmText.vue')),
  false,
);

export const modals = { confirm, confirmPassword, link, confirmText };
